<template>
  <el-card class="box-card mb-50 box-search">
    <span class="tilte-search mb-10">{{ $t('users.index.user_management') }}</span>
    <el-form ref="formSearch" @submit.prevent="search" :model="dataSearch">
      <template v-if="hasShopIdParam">
       <el-row>
          <div class="el-col mr-20">
            <el-form-item prop="filters[0][data]">
              <el-input class="company-name w-400" :placeholder="$t('users.mail_address')" v-model="dataSearch['filters[0][data]']"/>
              <span class="text-gray-500"></span>
            </el-form-item>
          </div>
          <div class="el-col">
            <el-form-item prop="name">
              <el-input class="shop-name w-400" :placeholder="$t('users.full_name')" v-model="dataSearch['filters[1][data]']"/>
            </el-form-item>
          </div>
        </el-row>
      </template>
      <div class="mt-25 mb-25">
        <el-button type="danger" class="btn-search" @click="search" @keyup.enter.native="search">{{
            $t('btn_search')
          }}
        </el-button>
        <el-button type="info" class="btn-clear" @click="resetForm">{{ $t('btn_clear') }}</el-button>
      </div>
    </el-form>
    <table-data
      :data="data" :loading="loading" :hasCreate="true"
      :columns="columns" :buttons="buttons"
      @change-page="handleChangePage"
      @handle-redirect-create="redirectCreate"
      @click-button="handleClickButtonTable"
      @sort="sort"
    >
    </table-data>
  </el-card>
</template>
<script>
import {getListData} from '../../api/user'

export default {
  props: {
    urls: { type: Object, required: true, default: {} },
  },

  data() {
    return {
      formSearch: {
        name: "",
      },
      hasShopIdParam: true,
      data: {},
      loading: true,
      listQuery: {
        page: 1,
        name: "",
        filter: "",
        "filters[0][key]": "mail_address",
        "filters[0][data]": "",
        "filters[1][key]": "full_name",
        "filters[1][data]": "",
      },
      columns: [
        {prop: "info", label: "ユーザー情報", sortable: false, class: ""},
        {prop: "point", label: "所有ココロン", sortable: "custom", class: "text-center"},
        {prop: "last_login_datetime", label: "最終ログイン日", sortable: "custom", class: ""},
      ],
      buttons: [
        {id: "2", label: "詳細", type: "detail", class: "btn btn-detail"}
      ],

      sortProp: {key: 'created_at', dir: 'descending'},
      dataSearch: {
        page: 1,
        name: "",
        filter: "",
        "filters[0][key]": "mail_address",
        "filters[0][data]": "",
        "filters[1][key]": "full_name",
        "filters[1][data]": "",
      },
    }
  },

  methods: {
    getListData() {
      const query = {...this.listQuery, ...this.sortProp}
      getListData(query)
          .then(response => response.json())
          .then(response => {
            response.data.records = response.data.records.map(e => {
              return {
                ...e,
                info: this.convertInfo(e.nickname ? e.nickname: '', e.full_name)
              }
            })
            this.data = response.data;
            this.loading = false;
          })
          .catch((error) => {
          })
          .finally(() => {

          });
    },

    handleChangePage(page) {
      this.loading = true;
      this.listQuery.page = page;
      this.getListData();
    },

    search() {
      this.loading = true;
      this.listQuery = Object.fromEntries(Object.entries(this.dataSearch).map(([k, v]) => [k, v]));
      this.listQuery.page = 1;
      this.getListData();
    },

    handleClickButtonTable(type, row) {
      switch (type) {
        case 'detail':
          window.location.href = "/users/" + row.id;
          break;
      }
    },

    sort(sortProps) {
      this.sortProp = {key: sortProps.prop, dir: sortProps.order};
      this.listQuery.page = 1;
      this.getListData();
    },

    resetForm() {
      this.dataSearch = {
        page: 1,
        name: "",
        filter: "",
        "filters[0][key]": "mail_address",
        "filters[0][data]": "",
        "filters[1][key]": "full_name",
        "filters[1][data]": ""
      }
    },

    convertInfo(nickName, fullName) {
      return `<span>${fullName}</span></br>
        <span v-html="info">${nickName}</span>`;
    },

    redirectCreate() {
      window.location.href = this.urls.create;
    }
  },

  watch: {
    filter() {
      this.handleFilter()
    }
  },
  created() {
    this.getListData();
  },
  handleFilter() {
    this.listQuery.page = 1
    this.getList({...this.listQuery, ...this.filterData})
  },
  getList(param) {

  }
}
</script>


<style lang="scss" scoped>
  .el-form {
    width: 100%
  }
</style>